import { ReactNode } from "react";

import { Plus, BarChart3 } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";

interface CrudManagerProps {
  title: string;
  description: string;
  onCreateNew: () => void;
  createLabel?: string;
  children: ReactNode;
  statsSection?: ReactNode;
  showStats?: boolean;
  onToggleStats?: () => void;
  additionalActions?: ReactNode;
  aiGenerationSection?: ReactNode;
}

export const CrudManager = ({
  title,
  description,
  onCreateNew,
  createLabel = "Create",
  children,
  statsSection,
  showStats = false,
  onToggleStats,
  additionalActions,
  aiGenerationSection,
}: CrudManagerProps) => {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold">{title}</h2>
          <p className="text-muted-foreground">{description}</p>
        </div>
        <div className="flex gap-2">
          {onToggleStats && (
            <Button variant="outline" onClick={onToggleStats}>
              <BarChart3 className="h-4 w-4 mr-2" />
              {showStats ? "Hide" : "Show"} Stats
            </Button>
          )}
          {additionalActions}
          <Button onClick={onCreateNew}>
            <Plus className="h-4 w-4 mr-2" />
            {createLabel}
          </Button>
        </div>
      </div>

      {/* Stats Section */}
      {showStats && statsSection && (
        <Card>
          <CardHeader>
            <CardTitle>Usage Statistics</CardTitle>
          </CardHeader>
          <CardContent>{statsSection}</CardContent>
        </Card>
      )}

      {/* AI Generation Section */}
      {aiGenerationSection}

      {/* Items Grid */}
      <div className="grid gap-4">{children}</div>
    </div>
  );
}
